import { ContractorRegionCreatableInterface } from '../interfaces/contractor-region-creatable.interface';
import { ContractorRegionDto } from './contractor-region.dto';
import { PickType } from '@nestjs/swagger';

export class ContractorRegionCreateDto
  extends PickType(ContractorRegionDto, ['contractorId', 'regionId'])
  implements ContractorRegionCreatableInterface {}
